export enum INVOICE_STATUS {
  Pending = 'Pending',
  Submitted = 'Submitted',
  Deleted = 'Deleted',
  Extracting = 'Extracting',
  ExtractionFailed = 'Extraction Failed',
}

export enum MODULES_NAMES {
  ORDERS = 'orders',
  INVOICE = 'invoice',
}

export enum INVOICE_PAYMENT_STATUS {
  PAID = 'Paid',
  UNPAID = 'Unpaid',
  APPROVAL_NEEDED = 'Approval Needed',
  REJECTED = 'Rejected',
  ALL = 'All',
}

export enum INVOICE_TYPE {
  ITEMIZED = 'Itemized',
  NON_ITEMIZED = 'NonItemized',
}

export enum INVOICE_ACTION_TYPES {
  CREATE = 'create',
  UPDATE = 'update',
  DRAFT_UPDATE = 'draft_update',
  SUBMIT = 'submit',
}

export enum INVOICE_LINE_ITEM_TYPES {
  INGREDIENT = 'Ingredient',
  NON_INGREDIENT = 'Non-Ingredient',
}

export enum INVOICE_FILE_SOURCES {
  WEB_DASH = 'Web Dash',
  MOM = 'MoM App',
}
